import React from 'react';
import { Box } from '@hub/box';
import { Segment } from './types';
import { TextWithJustHighlights } from './text-with-highlights';
import { jsx as _jsx } from "react/jsx-runtime";
export default function getDisplayNameForHit(hit) {
  const {
    segment
  } = hit;

  if (segment === 'productQuerySuggestions') {
    return "".concat(hit.query, " in ").concat(hit.productsCategory.displayTitle);
  }

  const isProduct = segment === 'westfieldProducts' || segment === 'products';
  return isProduct ? hit.name : hit.title;
}

function getFieldForSegment(segment) {
  if (segment === Segment.productQuerySuggestions) {
    return 'query';
  } else if (segment === Segment.westfieldProducts || segment === Segment.products) {
    return 'name';
  } else {
    return 'title';
  }
}

function getSupplementaryTextForHit(hit) {
  if (hit.segment === 'stores' || hit.segment === 'nearCentreStores') {
    return " ".concat(hit.centreName);
  } else if (hit.segment === 'retailers') {
    return ' Shop online';
  } else if (hit.segment === 'productQuerySuggestions') {
    const displayTitle = hit.productsCategory.displayTitle;
    return displayTitle ? " in ".concat(displayTitle) : '';
  }

  return '';
}

export const DisplayForHitWithHiglighting = _ref => {
  let {
    hit
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      '& > em': {
        fontWeight: 'bolder'
      }
    },
    "data-id": "search_get-display-name-for-hit_DisplayForHitWithHiglighting_Box",
    children: /*#__PURE__*/_jsx(TextWithJustHighlights, {
      doUseAutocompleteTags: hit.segment !== 'facetBrands',
      field: getFieldForSegment(hit.segment),
      hit: hit,
      supplementaryText: getSupplementaryTextForHit(hit),
      "data-id": "search_get-display-name-for-hit_DisplayForHitWithHiglighting_Box_TextWithJustHighlights"
    })
  });
};